import React from 'react'
import { InfoContent } from '../ContentInfoModal'
import NumberFormat from 'react-number-format'

const Currency = ({ value, symbol }) => (
  <NumberFormat
    value={value}
    fixedDecimalScale
    decimalScale={2}
    displayType="text"
    thousandSeparator
    prefix={symbol}
  />
)

const FinanceModal = (props) => {
  const financeData = {
    'Monthly Payments': (
      <Currency value={props.monthlyPayment} symbol={props.symbol} />
    ),
    'Car Price': <Currency value={props.carPrice} symbol={props.symbol} />,
    'Deposit Amount': (
      <Currency value={props.depositAmount} symbol={props.symbol} />
    ),
    'Admin Fee': <Currency value={props.adminFee} symbol={props.symbol} />,
    'Balance to Finance': (
      <Currency value={props.balanceToFinance} symbol={props.symbol} />
    ),
    'Term Length': props.numberOfPayments,
    'First Payment': (
      <Currency value={props.firstPayment} symbol={props.symbol} />
    ),
    'Optional Final Payment': (
      <Currency value={props.finalPayment} symbol={props.symbol} />
    ),
    'Includes Purchase Fee': (
      <Currency value={props.optionFee} symbol={props.symbol} />
    ),
    'Total Amount Payable': (
      <Currency value={props.amountPayable} symbol={props.symbol} />
    ),
    'Interest Charges': (
      <Currency value={props.interestCharges} symbol={props.symbol} />
    ),
    'Representative APR': props.interestApr + '%',
    'Interest Rate (fixed)': props.interestRate + '%'
  }
  return <InfoContent items={financeData} />
}

export default FinanceModal
